import React from 'react';

import NavigationItems from '../Navigation/NavigationItems';
import BookButtons from '../Navigation/BookButtons/BookButtons';
import Logo from '../Logo/Logo';
import SideBar from '../Navigation/SideBar/SideBar';

import classes from './Header.module.css';

const header = (props) => {
    const hamburgerClass = ['material-icons', classes.Toggle].join(' ');

    return (
        <header className={classes.Header}>
            <i className={hamburgerClass} onClick={props.bookShowToggle}>reorder</i>
            <Logo />
            <NavigationItems isAuth={props.isLoggedIn} role={props.role} currentId={props.currentId} />
            <BookButtons
                className={classes.WideScreen}
                bookShowToggle={props.bookShowToggle}
                bookShow={props.bookShow} />
            <SideBar show={props.bookShow} toggle={props.bookShowToggle} isAuth={props.isLoggedIn} role={props.role} />
        </header >
    );
}

export default header;